import _objectSpread from "D:/WebBuild/teamCity/buildAgent/work/f0b2174a44415a20/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import _slicedToArray from "D:/WebBuild/teamCity/buildAgent/work/f0b2174a44415a20/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import _regenerator from "D:/WebBuild/teamCity/buildAgent/work/f0b2174a44415a20/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _asyncToGenerator from "D:/WebBuild/teamCity/buildAgent/work/f0b2174a44415a20/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.error.cause.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.array.join.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import "core-js/modules/es.iterator.find.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.replace.js";
import { getDetail as _getDetail, edit, create, getList as _getList } from '@/api/setting/organization';
export default {
  name: 'organization-form',
  props: {
    id: {
      default: undefined
    },
    total: {},
    onlyReady: {
      default: false
    }
  },
  computed: {
    structureList: function structureList() {
      var _this = this;
      if (this.form.structure === 1) {
        return this.rootList;
      }
      return this.currentTableData.filter(function (item) {
        var codes = item.l01StrucCode.split('.');
        return codes.length === _this.form.structure - 1;
      });
    }
  },
  data: function data() {
    var _this2 = this;
    var validateStrucCode = function validateStrucCode(rule, value, callback) {
      if (!_this2.structureCode) {
        callback(new Error('请选择架构父级编码'));
      } else if (_this2.form.structure === 1 && value.length < 3) {
        callback(new Error('请输入四位架构编号，例：001'));
      } else if (_this2.form.structure !== 1 && value.length < 2) {
        callback(new Error('请输入两位架构标号，例：11'));
      } else {
        callback();
      }
    };
    return {
      structureCode: undefined,
      structureText: '',
      structProps: {
        value: 'l01StrucCode',
        id: 'l01Id',
        label: ['l01StrucCode', 'l01Name']
      },
      rootList: [{
        l01Id: 'A',
        l01Name: '会计',
        l01StrucCode: 'A'
      }, {
        l01Id: 'B',
        l01Name: '税务',
        l01StrucCode: 'B'
      }, {
        l01Id: 'C',
        l01Name: '咨询',
        l01StrucCode: 'C'
      }, {
        l01Id: 'D',
        l01Name: '造价',
        l01StrucCode: 'D'
      }, {
        l01Id: 'E',
        l01Name: '评估',
        l01StrucCode: 'E'
      }, {
        l01Id: 'F',
        l01Name: '法律',
        l01StrucCode: 'F'
      }],
      rules: {
        structure: [{
          required: true,
          message: '请选择架构级别',
          trigger: 'change'
        }],
        code: [{
          required: true,
          message: '请输入架构编码',
          trigger: 'change'
        }, {
          validator: validateStrucCode,
          trigger: 'change'
        }],
        l01Name: [{
          required: true,
          message: '请输入架构名称',
          trigger: 'change'
        }],
        l01ShortName: [{
          required: true,
          message: '请输入机构简称',
          trigger: 'change'
        }]
      },
      loading: false,
      form: {
        disabled: false,
        structure: 1,
        l01IsEffect: 'Y',
        code: undefined
      },
      currentTableData: []
    };
  },
  methods: {
    radioChange: function radioChange() {
      this.structureText = '';
      this.form.code = undefined;
      this.structureCode = undefined;
    },
    handleChange: function handleChange(val) {
      this.structureCode = val;
    },
    getList: function getList() {
      var _this3 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.n) {
            case 0:
              return _context2.a(2, new Promise(/*#__PURE__*/function () {
                var _ref = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(resolve) {
                  var _yield$_getList, data, datas;
                  return _regenerator().w(function (_context) {
                    while (1) switch (_context.n) {
                      case 0:
                        _context.n = 1;
                        return _getList({
                          length: _this3.total,
                          page: _this3.currentPage
                        });
                      case 1:
                        _yield$_getList = _context.v;
                        data = _yield$_getList.data;
                        datas = data.datas;
                        _this3.currentTableData = datas;
                        resolve();
                      case 2:
                        return _context.a(2);
                    }
                  }, _callee);
                }));
                return function (_x) {
                  return _ref.apply(this, arguments);
                };
              }()));
          }
        }, _callee2);
      }))();
    },
    cancel: function cancel() {
      this.$emit('cancel');
    },
    submit: function submit() {
      var _this4 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3() {
        var form, l01StrucCode, _yield$_this4$$awaitT, _yield$_this4$$awaitT2, err, _yield$_this4$$awaitT3, _yield$_this4$$awaitT4, _err;
        return _regenerator().w(function (_context3) {
          while (1) switch (_context3.n) {
            case 0:
              if (!_this4.onlyReady) {
                _context3.n = 1;
                break;
              }
              return _context3.a(2);
            case 1:
              _context3.n = 2;
              return _this4.$checkForm();
            case 2:
              _this4.loading = true;
              form = _this4.form;
              l01StrucCode = _this4.structureCode + (form.structure === 1 ? '' : '.') + _this4.form.code; // form.l01IsEffect = form.disabled ? 'Y' : 'N'
              if (!_this4.id) {
                _context3.n = 5;
                break;
              }
              _context3.n = 3;
              return _this4.$awaitTo(edit(_objectSpread(_objectSpread({}, form), {}, {
                l01StrucCode: l01StrucCode
              })));
            case 3:
              _yield$_this4$$awaitT = _context3.v;
              _yield$_this4$$awaitT2 = _slicedToArray(_yield$_this4$$awaitT, 1);
              err = _yield$_this4$$awaitT2[0];
              if (!err) {
                _context3.n = 4;
                break;
              }
              _this4.loading = false;
              return _context3.a(2);
            case 4:
              _context3.n = 7;
              break;
            case 5:
              _context3.n = 6;
              return _this4.$awaitTo(create(_objectSpread(_objectSpread({}, form), {}, {
                l01StrucCode: l01StrucCode
              })));
            case 6:
              _yield$_this4$$awaitT3 = _context3.v;
              _yield$_this4$$awaitT4 = _slicedToArray(_yield$_this4$$awaitT3, 1);
              _err = _yield$_this4$$awaitT4[0];
              if (!_err) {
                _context3.n = 7;
                break;
              }
              _this4.loading = false;
              return _context3.a(2);
            case 7:
              _this4.loading = false;
              _this4.$message.success('操作成功');
              _this4.$emit('submit');
            case 8:
              return _context3.a(2);
          }
        }, _callee3);
      }))();
    },
    getDetail: function getDetail() {
      var _this5 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4() {
        var _yield$_getDetail, data, form, l01StrucCode, codes, code, item;
        return _regenerator().w(function (_context4) {
          while (1) switch (_context4.n) {
            case 0:
              _context4.n = 1;
              return _getDetail({
                structCode: _this5.id
              });
            case 1:
              _yield$_getDetail = _context4.v;
              data = _yield$_getDetail.data;
              form = data;
              l01StrucCode = form.l01StrucCode;
              codes = l01StrucCode.split('.');
              form.structure = codes.length;
              if (codes.length > 1) {
                form.code = codes[codes.length - 1];
                codes.pop();
                _this5.structureCode = codes.join('.');
              } else {
                code = codes[0];
                form.code = code.replace(/\D/g, '');
                _this5.structureCode = code.replace(/[0-9]/g, '');
              }
              _this5.form = form;
              item = _this5.structureList.find(function (l) {
                return l.l01StrucCode === _this5.structureCode;
              });
              if (item) {
                // this.structureCode = `${item.l01Name}-${item.l01StrucCode}`;
              } else {
                // this.structureCode = this.structureCode
              }
            case 2:
              return _context4.a(2);
          }
        }, _callee4);
      }))();
    }
  },
  created: function created() {
    var _this6 = this;
    return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee5() {
      return _regenerator().w(function (_context5) {
        while (1) switch (_context5.n) {
          case 0:
            _context5.n = 1;
            return _this6.getList();
          case 1:
            if (_this6.id) {
              _this6.getDetail();
            }
          case 2:
            return _context5.a(2);
        }
      }, _callee5);
    }))();
  }
};